import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 27 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M3.72 13.068a10.126 10.126 0 1 0 12.4-7.16l-.616-.164 2.101-1.215a1.267 1.267 0 0 0-1.266-2.194L11.226 5.29a.844.844 0 0 0-.308 1.151l2.953 5.118a1.265 1.265 0 1 0 2.19-1.266l-1.21-2.105.417.114c4.041 1.08 6.62 5.184 5.594 9.243a7.592 7.592 0 0 1-10.673 4.974A7.593 7.593 0 0 1 7.476 11.06c.181-.231.28-.516.282-.81a1.262 1.262 0 0 0-2.249-.78 10.018 10.018 0 0 0-1.788 3.598Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }